/**
 * Centralized Date Utilities for Fish Shop Mumbai Online
 * Standard Application Display Format: DD/MM/YYYY
 */

export const formatDate = (dateVal) => {
  if (!dateVal) return '-';
  try {
    // If dateVal is a string like "2026-09-08" or "2026-09-08T00:00:00.000Z"
    const str = String(dateVal).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
      const parts = str.slice(0, 10).split('-');
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return str;

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (e) {
    return String(dateVal);
  }
};

export const getTodayInputDate = () => {
  return new Date().toISOString().slice(0, 10);
};
